import React, { memo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { closeGlobalAlert } from '../../actions/views'
import { MessageBar, MessageBarType } from '@fluentui/react/lib/MessageBar'
import style from './style.module.css'

const GlobalAlert = () => {
  const dispatch = useDispatch()
  const visible = useSelector(state => state.views.isGlobalAlertVisible)
  const message = useSelector(state => state.views.globalAlertMessage)
  
  const handleDismiss = () => {
    dispatch(closeGlobalAlert())
  }
  
  if (!visible) return null
  
  return (
    <div className={style.message}>
      <MessageBar
        messageBarType={MessageBarType.severeWarning}
        onDismiss={handleDismiss}
      >
        {message}
      </MessageBar>
    </div>
  )
}

export default memo(GlobalAlert)